import _ from 'lodash';
import LogRocket from 'logrocket';

// import CamIcon from 'Images/camera_marker.png';
import CamIcon from 'Images/generic_marker.png';
import PlaceholderImage from 'Images/eventsPanel/image-pending.jpg';
import panelTemplate from './tripWirePanel.html';
import modalTemplate from './tripWireModal.html';

export default {
  name: 'tripWire',
  template: panelTemplate,
  controllerAs: 'TripWireCtrl',
  controller: TripWireController,
  bindings: {
    panelId: '<'
  }
};

/* @ngInject */
function TripWireController(
  $scope,
  $uibModal,
  $compile,
  growl,
  EquipmentInfoService,
  TripWireService,
  DashboardService,
  MapService,
) {
  const vm = this;
  vm.placeholderImage = PlaceholderImage;

  /**
   * Public Variables
   */
  vm.loadingSpinners = {};
  vm.editPanel = {
    needsToBeConfigured: false
  };
  vm.tripwires = {};
  vm.headerModel = {};
  vm.cameras = [];
  vm.activeTripwire = {};
  vm.polyLines = {};
  vm.polylineMarkers = [];

  vm.cameraMarkers = [];
  vm.infoBoxes = [];
  vm.showTripWireCollapse = true;


  /**
   * Private Variables
   */
  const mapLat = 32;
  const mapLng = -97;
  const twoHun = 200;
  const divHalf = 2;
  const couPlus = 3;
  const cCoords = {
    size: {
      lat: 59,
      lng: 79
    },
    origin: {
      lat: 0,
      lng: 0
    },
    anchor: {
      lat: 14,
      lng: 58
    }
  };

  let tripwireMap;

  const mapOptions = {
    center: new google.maps.LatLng(mapLat, mapLng),
    zoom: 16,
    minZoom: 3,
    zoomControlOptions: {
      style: google.maps.ZoomControlStyle.LARGE,
      position: google.maps.ControlPosition.RIGHT_TOP
    },
    panControlOptions: {
      position: google.maps.ControlPosition.RIGHT_TOP
    },
  };

  const {
    MARKER_ICON_WIDTH,
    MARKER_ICON_HEIGHT,
    MARKER_ANCHOR_LAT,
    MARKER_ANCHOR_LNG
  } = MapService;

  /**
   * Public Methods
   */
  vm.$onInit = init;
  vm.$postLink = postLink;
  vm.fitMap = fitMap;
  vm.highlightPolyline = highlightPolyline;
  vm.lineTripped = lineTripped;
  vm.animateLine = animateLine;
  vm.removeIntervalsAndCloseInfoWins = removeIntervalsAndCloseInfoWins;
  vm.close = close;
  vm.showInfobox = showInfobox;
  vm.dismissLineEvent = dismissLineEvent;
  vm.toggleTripwireCollapse = toggleTripwireCollapse;
  vm.setActiveTripwire = setActiveTripwire;
  vm.isActiveTripWire = isActiveTripWire;
  vm.dismissAllEvents = dismissAllEvents;
  vm.openTWModal = openTWModal;
  vm.resetSelectedLineMarkers = resetSelectedLineMarkers;
  vm.setCenterToActiveTripWire = setCenterToActiveTripWire;
  vm.toggleSelectedLineMarkers = toggleSelectedLineMarkers;


  function init() {
    vm.currentDashboard = DashboardService.getCurrentDashboard();
    vm.panel = vm.currentDashboard.panels[vm.panelId];
    if (vm.panel) {
      if (vm.panel.equipment && vm.panel.equipment.length) {
        // panel is good to go
        vm.loadingSpinners.stopTripWirePanel = false;
        vm.editPanel.needsToBeConfigured = false;
        // vm.init(scope.panel);
        EquipmentInfoService.getFullEquipment(vm.panel.equipment)
          .then((equipment) => {
            const tripwireIdsArray = [];
            _.forEach(equipment, (anEquipment) => {
              // add tripwires to their own object
              if (anEquipment.equipmentType === 'tripwires') {
                vm.headerModel[anEquipment.id] = anEquipment;
                vm.tripwires[anEquipment.id] = {
                  equipment: anEquipment,
                  events: 0
                };
                tripwireIdsArray.push(anEquipment.id);
              }

              // add cameras to their own array
              if (anEquipment.equipmentType === 'cameras') {
                vm.cameras.push(anEquipment);
              }
            });

            TripWireService.getDismissableEventsFromOneDayAgo(tripwireIdsArray)
              .then((success) => {
                _.forEach(success.data, (event) => {
                  vm.tripwires[event.id].events = event.count;
                });

                if (_.size(vm.tripwires)) {
                  vm.activeTripwire = _.values(vm.tripwires)[0].equipment;
                  vm.selectedTripWire = vm.activeTripwire.id;
                }

                createTripWireMap();
              });
          });

      } else {
        // panel needs to be configured
        vm.loadingSpinners.stopTripWirePanel = true;
        vm.editPanel.needsToBeConfigured = true;
      }
    }
  } // End of init()

  function postLink() {

    // Add a watch to check if the panel has been resized to redraw the map
    $scope.$on('panel-resized', () => {
      MapService.safeResize(tripwireMap);
    });

    const toggleRouteChangeListener = $scope.$on('$stateChangeStart', () => {
      close();
      // this deletes the listener once it changes.
      toggleRouteChangeListener();
      MapService.destroyGoogleMaps(`#tripwire-location-${vm.panel.id}`);
      const startAndEndMarkers =
        _.reduce(vm.polyLines, (memo, lineObj) => [...memo, ..._.at(lineObj, 'startMarker', 'endMarker')], []);
      MapService.unsetMarkers([...vm.cameraMarkers, ...vm.polylineMarkers, ...startAndEndMarkers]);
    });
  }

  function fitMap() {
    if (tripwireMap) {
      MapService.fitZoomMap(tripwireMap, vm.polylineMarkers);
    }
  }

  // changes the option of the selected polyline and sets it equal to the activePolyline
  function highlightPolyline(lineId) {
    // remove this if statement when the time comes
    if (!vm.lineTripped(lineId)) {
      const lineSymbol = {
        strokeColor: '#000000',
        path: 'M 0,-1 0,1',
        strokeOpacity: 1,
        scale: 4
      };

      const polyEventOptions = {
        strokeColor: '#E14C37',
        strokeOpacity: 0.9,
        icons: [{
          icon: lineSymbol,
          offset: '100%',
          repeat: '30px'
        }],
        strokeWeight: 4
      };

      vm.polyLines[lineId].line.setOptions(polyEventOptions); // race condition -- needs refactor

      vm.polyLines[lineId].tripped = true;

      vm.animateLine(lineId);
    }
  }

  function lineTripped(lineId) {
    return _.isUndefined(vm.polyLines[lineId]) ? false : vm.polyLines[lineId].tripped;
  }

  function animateLine(lineId) {
    let count = 0;
    vm.polyLines[lineId].windowInterval = setInterval(() => {
      count = (count + couPlus) % twoHun;

      const icons = vm.polyLines[lineId].line.get('icons');
      if (icons[0]) {
        icons[0].offset = `${count / divHalf}%`;
        vm.polyLines[lineId].line.set('icons', icons);
      }
    }, twoHun);
  }

  function removeIntervalsAndCloseInfoWins() {
    MapService.removeIntervalsAndCloseInfoWins(vm.infoBoxes);
    _.forEach(vm.polyLines, (line) => {
      clearInterval(line.windowInterval);
    });
  }

  function close() {
    // This will close all info windows when user tries to open another or clicks the close button.
    removeIntervalsAndCloseInfoWins();
  }

  function showInfobox(idEquipment) {
    const marker = _.find(vm.cameraMarkers, ['id', idEquipment]);

    const infobox = _.find(vm.infoBoxes, ['id', idEquipment]);

    vm.close();
    $compile(infobox.content_)($scope);
    infobox.open(tripwireMap, marker);
    setTimeout(() => {
      infobox.content_.parentNode.parentNode.parentNode.style.width = '100%';
    }, 100);
  }

  function dismissLineEvent(lineId) {
    // clear the animateLine interval
    clearInterval(vm.polyLines[lineId]?.windowInterval);

    const polyOptions = {
      strokeColor: '#7CD646',
      strokeOpacity: 1,
      icons: [],
      strokeWeight: 4
    };

    vm.polyLines[lineId].line.setOptions(polyOptions);

    vm.polyLines[lineId].tripped = false;
  }

  function toggleTripwireCollapse() {
    vm.showTripWireCollapse = !vm.showTripWireCollapse;
  }

  function setActiveTripwire(wire) {
    // change the previous active trip wire markers back to normal colors
    vm.resetSelectedLineMarkers(vm.activeTripwire.id);

    vm.activeTripwire = wire;
    vm.selectedTripWire = wire.id;

    // center the map on the start marker of the new active trip wire
    vm.setCenterToActiveTripWire(vm.activeTripwire.id);

    // change the color of the markers to show which line is selected
    vm.toggleSelectedLineMarkers(vm.activeTripwire.id);
  }

  function isActiveTripWire(lineId) {
    return vm.activeTripwire && vm.activeTripwire.id === lineId;
  }

  function dismissAllEvents(tripwireId) {
    let growlMessage = growl.info('Dismissing Events...', {
      disableCloseButton: true
    });

    // First get all the non-dismissed events for this tripwire so we can broadcast them as dismissed
    TripWireService.getEventsDetailed(tripwireId)
      .then(({ data = [] }) =>
        TripWireService.dismissAllEvents(tripwireId).then(() => data))
      .then((events) => {
        // After dismissing, broadcast each event as updated with dismissed=true
        _.forEach(events, (event) => {
          // Mark the event as dismissed
          const dismissedEvent = {
            ...event,
            dismissed: true,
            _source: 'tripwirePanel' // Add source marker to help EventsPanel recognize the update
          };

          // Broadcast the event as updated
          $scope.$root.$broadcast('event:updated', dismissedEvent);
        });

        // Update UI and counter
        vm.tripwires[tripwireId].events = 0;
        vm.dismissLineEvent(tripwireId);

        if (growlMessage) {
          growlMessage.destroy();
          growlMessage = growl.success('Events Dismissed.');
        }
      })
      .catch((res) => {
        growlMessage.destroy();
        const error = 'Error Dismissing Events ';
        growlMessage = growl.error(res.error || 'An error occurred', { title: error });
        LogRocket.track(error);
      });
  }

  /*
     * Private methods
     */
  function createTripWireMap() {
    // Map for the Laser setup
    const mapElementWatcher = $scope.$watch(() => document.querySelector(`#tripwire-location-${vm.panel.id}`),
      (element) => {
        if (element) {
          mapElementWatcher();
          tripwireMap = new MapService.Map(element, vm.panel.id, mapOptions);

          // wait for the map to load
          MapService.waitForTilesLoaded(tripwireMap, () => {
            // recreate all of the polypaths as Google LatLng objects and add them to an array
            makeAllPolyLinesAndMarkers();
            // draw all of the polylines
            drawAllPolylines();
            if (vm.activeTripwire) {
              // center the map on the start marker of the new active trip wire
              setCenterToActiveTripWire(vm.activeTripwire.id);
            }

            // center the map and zoom to fit all the markers
            _.forEach(vm.tripwires, (tripwireModel) => {
              if (tripwireModel.events) {
                highlightPolyline(tripwireModel.equipment.id);
              }
            });
            setTimeout(() => {
              vm.fitMap();
              vm.loadingSpinners.stopTripWirePanel = true;
              $scope.$digest();
            }, 100);
          });
        }

        // check for trip wire events
        setSocketListeners();
      });

  }

  function drawAllPolylines() {
    _.forEach(vm.polyLines, (polyline) => {
      polyline.line = new google.maps.Polyline({
        path: polyline.path,
        strokeColor: '#7CD646',
        strokeOpacity: 1,
        strokeWeight: 4
      });

      polyline.line.setMap(tripwireMap);
    });
  }

  function setSocketListeners() {
    _.forEach(vm.tripwires, (__tripModel, eqId) => {
      $scope.$on(`event:${eqId}`, (__angularEvent, event) => {
        const { equipment } = event;
        if (shouldIgnoreEvent(event)) {
          return;
        }
        // Removed check for event.dismissed to stop hiding dismissed events
        vm.highlightPolyline(equipment.id);

        vm.tripwires[equipment.id].events += 1;
      });
    });

    $scope.$on('event:updated', (__, event) => {
      if (shouldIgnoreEvent(event)) {
        return;
      }

      const eqId = _.get(event, 'equipment.id', event.equipment);

      if (event.dismissed) {
        // Decrement count when an event is dismissed
        vm.tripwires[eqId].events -= 1;
        if (vm.tripwires[eqId].events < 0) {
          vm.tripwires[eqId].events = 0;
        }
        if (vm.tripwires[eqId].events === 0) {
          vm.dismissLineEvent(eqId);
        }
      } else {
        // NOTE: This code handles the undismiss scenario - while the UI doesn't currently
        // expose this functionality to users (dismiss buttons are disabled once clicked),
        // the underlying code supports toggling events back to undismissed. This ensures
        // the event counts and UI state remain consistent if events are undismissed through
        // other means (API, other components, or future UI changes).
        vm.tripwires[eqId].events += 1;
        if (vm.tripwires[eqId].events > 0 && !vm.lineTripped(eqId)) {
          vm.highlightPolyline(eqId);
        }
      }
    });
  }

  function shouldIgnoreEvent(event) {
    const { eventName, equipment, eventDate } = event;
    const eqId = _.get(equipment, 'id', equipment);
    if (!vm.tripwires[eqId]) {
      return true;
    }
    const now = new Date();
    if (new Date(eventDate) < now.setDate(now.getDate() - 1)) {
      return true;
    }
    if (eventName !== 'tripwires/tripped') {
      return true;
    }
    return false;
  }

  function makeAllPolyLinesAndMarkers() {
    _.forEach(vm.tripwires, (tripwire) => {
      const { start, end } = tripwire.equipment.settings;
      const poly = {};
      poly.start = new google.maps.LatLng(start.lat, start.lng);
      poly.end = new google.maps.LatLng(end.lat, end.lng);
      poly.path = [poly.start, poly.end];
      poly.tripped = false;

      const startIcon = {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 5,
        strokeWeight: 2,
        strokeColor: '#000000',
        fillColor: '#1CA105',
        fillOpacity: 1
      };
      const endIcon = {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 5,
        strokeWeight: 2,
        strokeColor: '#000000',
        fillColor: '#D54937',
        fillOpacity: 1
      };

      const startMarker = new MapService.Marker(tripwireMap, {
        name: `${tripwire.equipment.name} start`,
        id: `${tripwire.equipment.id} start`
      }, startIcon, false, { position: poly.start });

      const endMarker = new MapService.Marker(tripwireMap, {
        name: `${tripwire.equipment.name} end`,
        id: `${tripwire.equipment.id} end`
      }, endIcon, false, { position: poly.end });

      // assign the markers to the poly object to be easily referenced later
      poly.startMarker = startMarker;
      poly.endMarker = endMarker;

      // add polyline to array of all polylines
      vm.polyLines[tripwire.equipment.id] = poly;

      // push all the markers to an array to center the map
      vm.polylineMarkers.push(startMarker, endMarker);

      toggleSelectedLineMarkers(vm.activeTripwire.id);
    });

    // create the camera markers if any cameras are assigned to the panel
    if (vm.cameras.length > 0) {
      _.forEach(vm.cameras, (camera) => {
        const box = new MapService.CameraContentBox(camera, 'TripWireCtrl');
        vm.infoBoxes.push(new MapService.Infobox(camera.id, {
          content: box,
          // eslint-disable-next-line no-magic-numbers
          pixelOffset: new google.maps.Size(-200, -35)
        }));

        const camIcon = _.assign({}, {
          url: CamIcon,
          scaledSize: new google.maps.Size(MARKER_ICON_WIDTH, MARKER_ICON_HEIGHT),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(MARKER_ANCHOR_LAT, MARKER_ANCHOR_LNG)
        }, cCoords);
        // create map marker
        const cameraMarker = new MapService.Marker(tripwireMap, camera, camIcon, false, { zIndex: 0 });

        // add the marker to the array of camera markers
        vm.cameraMarkers.push(cameraMarker);

        // Adds listener on click to marker
        google.maps.event.addListener(cameraMarker, 'click', () => {
          vm.showInfobox(cameraMarker.id);
        });
      });
    }
  }

  function resetSelectedLineMarkers(lineId) {
    const startMarker = vm.polyLines[lineId].startMarker;
    const endMarker = vm.polyLines[lineId].endMarker;

    const startOptions = {
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 5,
        strokeWeight: 2,
        strokeColor: '#000000',
        fillColor: '#1CA105',
        fillOpacity: 1
      },
      zIndex: 0
    };

    const endOptions = {
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 5,
        strokeWeight: 2,
        strokeColor: '#000000',
        fillColor: '#D54937',
        fillOpacity: 1
      },
      zIndex: 0
    };

    startMarker.setOptions(startOptions);
    endMarker.setOptions(endOptions);
  }

  function setCenterToActiveTripWire(lineId) {
    tripwireMap.setCenter(vm.polyLines[lineId].start);
  }

  function toggleSelectedLineMarkers(lineId) {
    const startMarker = vm.polyLines[lineId].startMarker;
    const endMarker = vm.polyLines[lineId].endMarker;

    const startOptions = {
      icon: {
        path: 'M -2,0 0,-2 2,0 0,2 z',
        scale: 3,
        strokeWeight: 3,
        strokeColor: '#046bb5',
        fillColor: '#1CA105',
        fillOpacity: 1
      },
      zIndex: 1
    };

    const endOptions = {
      icon: {
        path: 'M -2,0 0,-2 2,0 0,2 z',
        scale: 3,
        strokeWeight: 3,
        strokeColor: '#046bb5',
        fillColor: '#D54937',
        fillOpacity: 1
      },
      zIndex: 1
    };

    startMarker.setOptions(startOptions);
    endMarker.setOptions(endOptions);
  }

  function openTWModal(tripwireId) {
    const modalInstance = $uibModal.open({
      template: modalTemplate,
      controller: 'TripWireModalController',
      controllerAs: 'TripWireModalCtrl',
      size: 'full',
      resolve: {
        tripWire: () => vm.tripwires[tripwireId]
      }
    });
    modalInstance.result
      .then((count) => {
        if (_.isNumber(count)) {
          vm.tripwires[tripwireId].events = count; // update count from modal
        }
      });
  }
}
